// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"pageTitle_titleContainer__26NKB","title":"pageTitle_title__2Sngh"};